import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {BrowserRouter} from 'react-router-dom';
import VhtApplicationContext from '../vht-application-context';
import VhtApplication from '../vht-application';
import Router from '../router';
import authProvider from '../../auth/auth0-provider';
import SessionTimeoutModal from '../session-timeout-modal';
import ajaxSetup from '../../utils/ajax-setup';
import ErrorView from '../../views/error';
import CenteredBoxLayout from '../../layouts/centered-box';
import configInitializer from '../../config/initializer';

import '../../styles/app.scss';

export default function VhtApplicationBootstrapper(props) {
  const {applications, initializers = [], error = false} = props;
  const sessionTimeoutModalRef = React.useCallback(component => ajaxSetup.init(component), []);
  const navigation = React.useMemo(() => {
    return applications.reduce((merged, application) => {
      merged.push(...application.navigation);
      return merged;
    }, []);
  }, [applications]);

  return (
    <VhtApplicationContext applications={applications} navigation={navigation}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <VhtApplication initializers={initializers} navigation={navigation}>
          <SessionTimeoutModal ref={sessionTimeoutModalRef} />
          {error && (
            <CenteredBoxLayout>
              <ErrorView />
            </CenteredBoxLayout>
          )}
          {!error && <Router applications={applications} />}
        </VhtApplication>
      </BrowserRouter>
    </VhtApplicationContext>
  );
}

VhtApplicationBootstrapper.init = async function(applications) {
  await configInitializer();
  const success = await authProvider.initialize();
  ReactDOM.render(
    <VhtApplicationBootstrapper applications={applications} error={!success} />,
    document.getElementById('root'),
  );
};

VhtApplicationBootstrapper.propTypes = {
  /** An array representing the application modules. */
  applications: PropTypes.array.isRequired,
  /** An array of async functions to resolve before rendering this application's content. */
  initializers: PropTypes.array,
  /** Whether or not to force the error view to show */
  error: PropTypes.bool,
};
